<div class="normalScreen" style="background:white">
  <form [formGroup]="searchForm" (ngSubmit)="search()">
    <div style="margin-left:10px;margin-top:10px">
      <mat-form-field>
        <input matInput data-cy="transferDate" [matDatepicker]="date" [max]="maxDate" placeholder="Datum" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Hållplats</mat-label>
        <mat-select data-cy="busID" placeholder="Hållplats" formControlName="transfer">
          <mat-option *ngFor="let loc of locations" [value]="loc">
            {{loc.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <button mat-flat-button color="primary" data-cy="searchTransfer" type="submit" style="margin-left:10px;background:#7AB800" [disabled]="!canSearch()">Sök</button>
      <button mat-flat-button color="primary" data-cy="exportTransfer" type="button" (click)="export()" style="margin-left:10px;background:#7AB800" [disabled]="!canExport()">Exportera till Excel</button>
    </div>
  </form>
  <div style="margin-left:10px;margin-top:25px" *ngIf="noMatch && canSearch()" class="alert alert-info">
    <label>Hittade inga matchande transfers.</label>
  </div>
  <div width="1600">
    <ngx-spinner #spinner [config]="spinnerConfig">
    </ngx-spinner>
    <div style="margin-left:10px;margin-top:25px;">
      <mat-accordion displayMode="flat" multi="true" style="display:block">
        <mat-expansion-panel *ngFor="let detail of ( transferReport ? transferReport.transferDetails: [])">
          <mat-expansion-panel-header style="font-weight:bold" [ngClass]="{'NoShow': hasNoshow(detail.activities)}">
            {{getTime(detail.date)}} {{detail.driver}}
          </mat-expansion-panel-header>
          <ag-grid-angular style="width:400px;height:300px;margin-left:10px;margin-top:10px"
                           #activities
                           class="ag-theme-material"
                           [enableColResize]="true"
                           [enableFilter]=true
                           [animateRows]="true"
                           [enableSorting]="true"
                           [rowData]="detail.activities"
                           [localeText]="localeText"
                           [columnDefs]="columnDefs">
          </ag-grid-angular>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

  </div>
</div>
